<template>
  <div>
    <div class="col-12">
      <Title :page="page" />
      <breadcrumb :page="page" />
    </div>
    <div class="col-12">
      <div class="col-12 w-defined">
        <div class="p-0" :class="{ 'sticky-bottom-right': stickyButtons }">
          <router-link
            id="btnPeiDetail"
            :to="linkBack"
            tag="button"
            class="btn btn-green btn-tabHeader p-0 mr-4"
          >
            <i class="fas fa-arrow-circle-left" />
            <span class="pl-2">Regresar</span>
          </router-link>
          <ActionButton
            v-if="!isSubmitted"
            variant="success btn btn-green btn-tabHeader p-0 m-0"
            i="fas fa-save"
            :disabled="disabled"
            @click="$emit('onSubmit')"
          >
            Someter
          </ActionButton>
          <ActionButton
            v-if="isSubmitted && showUnSubmit"
            variant="success btn btn-green btn-tabHeader p-0 m-0"
            i="fas fa-undo"
            :disabled="disabled"
            @click="$emit('onUnSubmit')"
          >
            Restablecer
          </ActionButton>
          <ActionButton
            v-if="isCompleted"
            variant="outline-success btn btn-green btn-tabHeader p-0 ml-4"
            i="fas fa-print pr-1"
            @click="downloadReport"
          >
            Imprimir
          </ActionButton>
        </div>
      </div>
      <!-- <div class="tag-badge-info">
        <span class="tag-badge-title-info pb-2 pl-3">Definiciones para puntuaciones de indicadores</span>
      </div> -->
      <div class="dropdown-divider mt-1 w-100" />
    </div>

    <div class="col-12">
      <Accordion id="evaluationInfo">
        <AccordionItem
          id="evaluationInfoItem"
          title="Información de Escala de Evaluación"
          content-style="col-md-7 text-left"
          action-style="col-md-2 text-right"
        >
          <div slot="content" class="card-body p-0">
            <div class="panel-info">
              <div class="panel-content">
                <div class="row d-flex">
                  <div class="panel-box panel-box-green">
                    <span class="panel-number">7</span>
                  </div>
                  <div class="col-md-11 col-sm-12 panel-body">
                    <strong>Completamente</strong>
                    <p>
                      Muestra funcionamiento esperado para su edad o casi todas
                      las situaciones de su diario vivir. Su funcionamiento es
                      apropiado a su edad. No hay preocupaciones sobre el
                      funcionamiento de el/la niño(a) en estas áreas de
                      indicaciones.
                    </p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-white">
                    <span class="panel-number">6</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <br />
                    <p>
                      Entre “Completamente” y “A veces”. Su funcionamiento es
                      generalmente considerado como apropiado para su edad, pero
                      existen algunas preocupaciones sobre el funcionamiento de
                      el/la niño(a) en este indicador.
                    </p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-yellow">
                    <span class="panel-number">5</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <strong>A veces</strong>
                    <p>
                      Muestra funcionamiento esperado para su edad en algunos
                      momentos o algunas situaciones. Su funcionamiento fluctúa
                      entre apropiado y no apropiado. Su funcionamiento puede
                      ser descrito como el de un(a) niño(a) ligeramente menor.
                    </p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-white">
                    <span class="panel-number">4</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <br />
                    <p>Entre “A veces” y “Comenzando”.</p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-red">
                    <span class="panel-number">3</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <strong>Comenzando</strong>
                    <p>
                      Aún no muestra funcionamiento esperado para un(a) niño(a)
                      de su edad en ninguna situación. Su conducta y destreza
                      incluyen destrezas fundamentales sobre las que puede
                      construir funcionamiento apropiado a su edad. Su
                      funcionamiento puede describirse como el de un(a) niño(a)
                      menor.
                    </p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-white">
                    <span class="panel-number">2</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <br />
                    <p>Entre “Comenzando” y “Aún no”.</p>
                  </div>
                </div>
              </div>
              <div class="panel-content">
                <div class="row">
                  <div class="panel-box panel-box-brown">
                    <span class="panel-number">1</span>
                  </div>
                  <div class="col-md-11 panel-body">
                    <strong>Aún No</strong>
                    <p>
                      Aún no muestra un funcionamiento esperado para un(a)
                      niño(a) de su edad en ninguna situación. Su conducta y
                      destreza aún no incluyen ninguna destreza básica sobre la
                      que pueda construir funcionamiento apropiado a su edad. Su
                      funcionamiento puede ser descrito como el de un(a) niño(a)
                      significativamente menor.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AccordionItem>
      </Accordion>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import Title from '@/components/common/page/Title';
import generalService from "@/services/pei/general";
import ActionButton from '@/components/common/ActionButton';
import breadcrumb from '@/components/common/page/BreadCrumb';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';

export default {
  name: 'IndicatorScore',
  components: {
    breadcrumb,
    Title,
    ActionButton,
    Accordion,
    AccordionItem,
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Cuestionario de Intervención',
        routes: [
          'Inicio',
          'PEI',
          'Crear',
          'Modificar PEI',
          'Cuestionario de Intervención',
        ],
      },
      stickyButtons: {
        type: Boolean,
        Default: false,
      },
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    isSubmitted: {
      type: Boolean,
      default: () => false,
    },
    isCompleted: {
      type: Boolean,
      default: () => false,
    },
    linkBack: {
      type: String,
      default: () => '',
    },
    showUnSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 200) {
        this.stickyButtons = true;
      } else {
        this.stickyButtons = false;
      }
    },
    async downloadReport() {
      const res = await this.$ApiGet(`/api/report/ind7report/sie/${store.getters['$_student/StudentSie']}`);
      generalService.documentDownloadReport(
        res.data.content,
        res.data.filename
      );
    },
  },
};
</script>

<style scoped>
.panel-info {
  width: 100%;
}

.panel-info .row {
  margin: none;
}

.panel-info .panel-header {
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 7px 7px 0px 0px;
  display: flex;
  color: #ffffff;
  padding: 1.5%;
}

.panel-info .panel-title {
  text-align: center;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.panel-info .panel-content {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 0px;
  border-top: solid 1px #eaeaea;
  border-bottom: solid 1px #eaeaea;
  margin-left: 15px;
  margin-top: -5px;
  height: 110px;
}

.panel-info .panel-content:nth-child(2n + 1) {
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
}

.panel-info .panel-content .panel-body {
  padding: 20px 20px 10px 25px;
}

.w-defined {
  display: flex;
  flex-direction: row-reverse;
}

.sticky-bottom-right {
  position: fixed;
  bottom: 50px;
  right: 80px;
  z-index: 1;
}

.panel-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 5px;
  width: 40px;
  min-height: 110px;
}
.panel-box-green {
  background: #a3e5b3;
}
.panel-box-white {
  background: #f4f6f3;
}
.panel-box-yellow {
  background: #f8eb7f;
}
.panel-box-red {
  background: #fcc9c8;
}
.panel-box-brown {
  background: #d5b89a;
}

.panel-box-green,
.panel-box-white,
.panel-box-yellow,
.panel-box-red,
.panel-box-brown span.panel-number {
  text-align: left;
  font: Bold 30px/36px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  padding-left: 8px;
}

@media only screen and (max-width: 768px) {
  .panel-info .panel-content {
    height: auto;
  }
  .panel-body {
    flex: 1;
  }
}

@media only screen and (max-width: 768px) {
  .panel-info .panel-content {
    height: auto;
  }
  .panel-body {
    flex: 1;
  }
}
</style>
